import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#1a1a2e] border-t border-white/10 text-white/50 py-12 text-center text-sm" data-id="element-53">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-54">
        <div className="font-heading text-xl md:text-2xl text-white/90 mb-4" data-id="element-55">
          Competir Sin Miedo
        </div>
        <p className="mb-8 max-w-md mx-auto leading-relaxed" data-id="element-56">
          Herramientas prácticas de fortaleza mental para futbolistas jóvenes y
          sus familias.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-10" data-id="element-57">
          <a href="#" className="hover:text-white transition-colors" data-id="element-58">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-59">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-60">
            Contacto
          </a>
        </div>

        <p className="mb-2" data-id="element-61">
          &copy; {currentYear} Competir Sin Miedo. Todos los derechos
          reservados.
        </p>
        <p className="text-xs opacity-60 max-w-2xl mx-auto leading-relaxed" data-id="element-62">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}